import React from 'react'

function DetailModal({item, onClose}) {
  return (
    <div className='w-full h-[100%] bg-black flex justify-center items-center text-black bg-opacity-80 absolute'>
        <div style={{backgroundColor: '#D4BBDD'}} className=' h-[23vmax] w-[50vmax] rounded-[0.5vmax] p-[2vmax] flex flex-col justify-center items-start text-[1.3vmax]'>
            <div className='text-black font-bold text-[2vmax] w-full flex justify-center items-center'>{item.name}</div>
        <div><span className='font-bold'>1) What are your Cleanliness Preferences?</span>{" "+item.questionOne}</div>
        <div><span className='font-bold'>2) Would Your Friends Call You Quite or Loud?</span>{" "+item.questionTwo}</div>
        <div><span className='font-bold'>3) Are you a Night Owl or an Early Bird?</span>{" "+item.questionThree}</div>
        <div><span className='font-bold'>4) Are you OK Sleeping with Lights ON?</span>{" "+item.questionFour}</div>
        <div><span className='font-bold'>5) How often you might have friends coming over to your room?</span>{" "+item.questionFive}</div>
        <div><span className='font-bold'>6) What are you mostly into?</span>{" "+item.questionSix}</div>
        <div><span className='font-bold'>7) Specific Concern</span>{" "+item.specific}</div>
        <div className='w-full flex justify-center items-center'><button style={{backgroundColor: '#5E376D'}} onClick={(e)=>{
            e.preventDefault();
            onClose();
        }} className='text-white font-bold text-[1.5vmax] p-[0.5vmax] rounded-[0.5vmax] bg-white'>Close</button></div>
        </div>
    </div>
  )
}

export default DetailModal